/**
 * Build-time settings. Every VITE_* value is inlined into the public bundle, so none of them is a
 * secret: the API's protection is the signed-in person's token, not anything in this file.
 */
const env = import.meta.env;

export const config = {
  apiBaseUrl: (env.VITE_API_BASE_URL ?? "http://localhost:4000").replace(/\/+$/, ""),
  authMode: (env.VITE_AUTH_MODE === "dev" ? "dev" : "oidc") as "dev" | "oidc",
  oidcIssuer: env.VITE_OIDC_ISSUER ?? "",
  oidcClientId: env.VITE_OIDC_CLIENT_ID ?? "",
  /** The phone desk. Click-to-dial opens it, in its own reused tab. */
  deskUrl: (env.VITE_DESK_URL ?? "https://switchcx.com").replace(/\/+$/, ""),
};
